/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * List items default to `content-visibility: auto` for lazy initial render.
 * On scroll set all row items to `content-visibility: visible` for eager render.
 * This allows fast first render and smooth eager rendering anytime after for items within a bounded scroll box.
 */
export function scrollableVisibility() {
    return (target) => target.addInitializer((instance) => new ScrollableVisibilityController(instance));
}
export class ScrollableVisibilityController {
    constructor(host) {
        this.host = host;
        this.host.addController(this);
    }
    get root() {
        return this.host.shadowRoot ? this.host.shadowRoot : this.host;
    }
    async hostConnected() {
        await this.host.updateComplete;
        this.root.addEventListener('scroll', () => this.host.style.setProperty('--row-content-visibility', 'visibile'), {
            once: true,
            capture: true,
        });
    }
}
